export enum DomainEventType {
    CHANGE_LANGUAGE = 'CHANGE_LANGUAGE',
}

export class DomainEvent<Detail = any> {
    constructor(public type: DomainEventType, public detail: Detail) {}
}
